"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _routes = _interopRequireDefault(require("./routes"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _notification = _interopRequireDefault(require("../notification"));

var _spinnerOverlay = _interopRequireDefault(require("../spinner-overlay"));

var _pageHeader = _interopRequireDefault(require("../page-header"));

var _store = _interopRequireDefault(require("./store"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var store = (0, _store.default)();

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.secret-manager-app-container {\n  margin: -20px -20px 0; }\n  .secret-manager-app-container .typography-label-02 {\n    color: #393939; }\n  .secret-manager-app-container .typography-label-01 {\n    color: #525252; }\n";
  var fileName = "compone_secretModule";
  var element = document.querySelector("style[data-sass-component='compone_secretModule']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var ProfilePolicy = function ProfilePolicy(_ref) {
  var history = _ref.history,
      match = _ref.match,
      _ref$appManage = _ref.appManage,
      appManage = _ref$appManage === void 0 ? true : _ref$appManage,
      _ref$cacheData = _ref.cacheData,
      cacheData = _ref$cacheData === void 0 ? null : _ref$cacheData,
      _ref$cachePapPolicyDa = _ref.cachePapPolicyData,
      cachePapPolicyData = _ref$cachePapPolicyDa === void 0 ? function () {} : _ref$cachePapPolicyDa;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "secret-manager-app-container"
  }, /*#__PURE__*/_react.default.createElement(_reactRedux.Provider, {
    store: store
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Router, {
    history: history
  }, /*#__PURE__*/_react.default.createElement(_notification.default, null), /*#__PURE__*/_react.default.createElement(_spinnerOverlay.default, null), /*#__PURE__*/_react.default.createElement(_pageHeader.default, null), /*#__PURE__*/_react.default.createElement(_routes.default, {
    history: history,
    match: match,
    appManage: appManage,
    cacheData: cacheData,
    cachePapPolicyData: cachePapPolicyData
  }))));
};

ProfilePolicy.propTypes = {
  history: _propTypes.default.any,
  match: _propTypes.default.any,
  appManage: _propTypes.default.bool,
  cacheData: _propTypes.default.object,
  cachePapPolicyData: _propTypes.default.func
};
var _default = ProfilePolicy;
exports.default = _default;